import React, { useEffect, useReducer } from 'react';

// REDUX
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import { checkUserSession, getAuthenticateData, getConfigurationDataLoadedState, getHttpError } from '@Managers/Redux/HttpState/HttpState';
import { setReadyState, setMaintananceMode, getEnvironmentConfiguration } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from '@UILayer/UILayer.scss';

// TYPES
import { IinitialState } from './ReadyStateCheck.types';

// CONFIG
import ConfigLoader from '@ConfigLoader/ConfigLoader';

// MANAGERS
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

// ELEMNTS
import { MissingFieldsMessage } from './ReadyStateCheck.missingFieldsMessage';

// TOOLS
import AuthCreditionalCheck from '@Tools/AuthCreditionalCheck';
import { TCreditionals } from '@Services/HttpService/HttpService.types';
import SocketService from '@Services/SocketService/SocketService';
import { ReadyStateCheckError } from './ReadyStateCheck.error';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

export const initialState: any = {
    missingFields: []
};

const ReadyStateCheck: React.FC<{}> = () => {
    const mandatoryUrlParams = ConfigLoader.authCreditionals || [];
    const urlParams = ConfigLoader.urlParameters;

    const dispatch = useAppDispatch();
    const authenticateData = useAppSelector(getAuthenticateData);
    const configurationDataLoaded = useAppSelector(getConfigurationDataLoadedState);
    const httpError = useAppSelector(getHttpError);

    const [state, setState] = useReducer((state: any, newState: IinitialState) => ({ ...state, ...newState }), initialState);

    useEffect(() => {
        Logger.log(LoggerLevel.UseEffect, { source: LoggerSource.React, component: 'ReadyState', message: 'REACT :: VIEW :: READYSTATE' });
    }, []);

    useEffect(() => {
        if (configurationDataLoaded) {
            let AuthCreditional = AuthCreditionalCheck(mandatoryUrlParams, urlParams);
            if (AuthCreditional.checkPass) {
                dispatch(checkUserSession(AuthCreditional.creditionals));
            } else {
                setState({ missingFields: AuthCreditional.missingFields });
            }
        }
    }, [configurationDataLoaded]);

    useEffect(() => {
        if (authenticateData?.token) {
            ConfigLoader.setAuthToken(authenticateData.token);
            SocketService.init();
            dispatch(setReadyState(true));
        }

        if (authenticateData?.isUnderMaintenance) {
            dispatch(setMaintananceMode({ active: true }));
        }
    }, [authenticateData]);

    useEffect(() => {}, [httpError]);

    return (
        <div className={styles.ready_state_container}>
            <div className={styles.ready_state_wrapper}>
                <MissingFieldsMessage fields={state.missingFields} />
                <ReadyStateCheckError />
            </div>
        </div>
    );
};

export default ReadyStateCheck;
